import HeatmapLayer from '@/components/heatmap/HeatmapLayer'
import axios from 'axios'
import { apiPath } from './utils'

export default class GeoHeatmapLayer extends HeatmapLayer {
  getData () {
    return axios.get(apiPath(this.heatmap.$route, this.service))
  }
}



// WEBPACK FOOTER //
// ./frontend/src/pages/Geo/components/GeoHeatmapLayer.js